import { render, staticRenderFns } from "./ConversationAvatarEditor.vue?vue&type=template&id=2d92575c&scoped=true"
import script from "./ConversationAvatarEditor.vue?vue&type=script&lang=js"
export * from "./ConversationAvatarEditor.vue?vue&type=script&lang=js"
import style0 from "./ConversationAvatarEditor.vue?vue&type=style&index=0&id=2d92575c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d92575c",
  null
  
)

export default component.exports